import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import Header from './components/Header';
import BottomNav from './components/BottomNav';
import HomePage from './pages/HomePage';
import SheepDetailPage from './pages/SheepDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import MyOrdersPage from './pages/MyOrdersPage';
import './responsive.css';

function Layout() {
  const [search, setSearch] = useState('');

  return (
    <div style={{ minHeight: '100dvh', background: 'var(--bg)', position: 'relative' }}>
      <Routes>
        <Route path="/" element={
          <>
            <Header onSearchChange={setSearch} searchValue={search} />
            <HomePage search={search} />
          </>
        } />
        <Route path="/sheep/:id" element={<SheepDetailPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success/:id" element={<OrderSuccessPage />} />
        <Route path="/orders" element={<MyOrdersPage />} />
      </Routes>
      <BottomNav />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </AppProvider>
  );
}
